class ProductSwitcher {
  constructor(container) {
    this.container = container;
    this.items = this.container.querySelectorAll(".HorizontalList__Item");
    this.init();
  }

  init() {
    this.items.forEach((item) => {
      const radio = item.querySelector('input[type="radio"]');
      if (radio) {
        radio.addEventListener("change", () => {
          this.handleItemClick(item);
        });

        // Also add click handler to the label for better UX
        const label = item.querySelector("label");
        if (label) {
          label.addEventListener("click", () => {
            radio.checked = true;
            this.handleItemClick(item);
          });
        }
      }
    });
  }

  handleItemClick(item) {
    const productUrl = item.dataset.productUrl;
    if (productUrl) {
      window.location.href = productUrl;
    }
  }
}

// Initialize all product switchers on the page
document.addEventListener("DOMContentLoaded", () => {
  const switchers = document.querySelectorAll(".product-switcher");
  switchers.forEach((switcher) => new ProductSwitcher(switcher));
});
